export default class Project {
  #id = ''
  #name = ''
  #companyId = ''
  #companyName = ''
  #city = ''
  #modality = ''
  #applyCoupon = false

  static fromJSONResponse(json) {
    return new Project()
      .setId(json.id)
      .setName(json.name)
      .setCompanyId(json.company_id)
      .setCompanyName(json.company_name)
      .setCity(json.city)
      .setModality(json.modality)
      .setApplyCoupon(json.apply_gift_voucher)
  }

  getId() {
    return this.#id
  }

  getName() {
    return this.#name
  }

  getCompanyId() {
    return this.#companyId
  }

  getCompanyName() {
    return this.#companyName
  }

  setId(value) {
    this.#id = value
    return this
  }

  setName(value) {
    this.#name = value
    return this
  }

  setCompanyId(value) {
    this.#companyId = value
    return this
  }

  setCompanyName(value) {
    this.#companyName = value
    return this
  }

  getCity() {
    return this.#city
  }

  setCity(value) {
    this.#city = value
    return this
  }

  getModality() {
    return this.#modality
  }

  isPostpaid() {
    return this.#modality === 'POSTPAID'
  }

  setModality(value) {
    this.#modality = value
    return this
  }

  getApplyCoupon() {
    return this.#applyCoupon
  }

  setApplyCoupon(value) {
    this.#applyCoupon = value
    return this
  }
}
